import { library } from '@fortawesome/fontawesome-svg-core'

import {
  faPhone,
  faGraduationCap,
  faTags,
  faExchangeAlt,
  faCreditCard,
  faMapMarker,
  faPhoneSquare,
  faMailBulk,
  faBuilding,
  faUsers,
  faUserTimes,
  faUserCheck,
  faHourglass,
  faEyeSlash,
  faArchive,
  faDownload,
  faCopy,
  faTimes,
  faArrowLeft,
  faEnvelope,
  faUser,faSignOutAlt,
  faEye,
  faEdit,
  faTrash,
  faCommentDots,
  faLock,
  faChevronUp,
  faChevronDown,
  faInfo,
  faClock,
  faExclamationTriangle,
  faPlus,
  faCaretDown,
  faUserSlash,
  faShoppingCart,
  faFile,
  faSearchPlus,
  faGem,
  faCheckSquare,
  faCheck,
  faTasks,
  faFolder,
  faFolderPlus,
  faFileSignature,
  faPlusSquare,
  faPenSquare,
  faExternalLinkSquareAlt
} from '@fortawesome/free-solid-svg-icons';

library.add(
  faPhone,
  faGraduationCap,
  faTags,
  faExchangeAlt,
  faCreditCard,
  faMapMarker,
  faPhoneSquare,
  faMailBulk,
  faBuilding,
  faUsers,
  faUserTimes,
  faUserCheck,
  faHourglass,
  faEyeSlash,
  faArchive,
  faDownload,
  faCopy,
  faTimes,
  faArrowLeft,
  faEnvelope,
  faUser,faSignOutAlt,
  faEye,
  faEdit,
  faTrash,
  faCommentDots,
  faLock,
  faChevronUp,
  faChevronDown,
  faInfo,
  faClock,
  faExclamationTriangle,
  faPlus,
  faCaretDown,
  faUserSlash,
  faShoppingCart,
  faFile,
  faSearchPlus,
  faGem,
  faCheckSquare,
  faCheck,
  faTasks,
  faFolder,
  faFolderPlus,
  faFileSignature,
  faPlusSquare,
  faPenSquare,
  faExternalLinkSquareAlt
)